// dashboardSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Async thunks for fetching dashboard data
export const fetchDashboardStatus = createAsyncThunk(
  'dashboard/fetchStatus',
  async () => {
    const response = await fetch(`${API_BASE_URL}/dashboard/dashboard/status`);
    if (!response.ok) throw new Error('Failed to fetch status');
    return response.json();
  }
);

export const fetchDashboardAlerts = createAsyncThunk(
  'dashboard/fetchAlerts',
  async () => {
    const response = await fetch(`${API_BASE_URL}/dashboard/dashboard/alerts`);
    if (!response.ok) throw new Error('Failed to fetch alerts');
    return response.json();
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    status: {
      PE: 0,
      L1: 0,
      L2: 0,
      PO: 0,
      PH: 0,
      SO: 0,
      SH: 0,
      Used: 0
    },
    alerts: {
      default: [],
      danger: [],
      alert: [],
      warning: []
    },
    loading: false,
    error: null
  },
  reducers: {
    clearDashboardError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Status fetch cases
      .addCase(fetchDashboardStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardStatus.fulfilled, (state, action) => {
        state.status = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchDashboardStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Alerts fetch cases
      .addCase(fetchDashboardAlerts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardAlerts.fulfilled, (state, action) => {
        state.alerts = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchDashboardAlerts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearDashboardError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
